import { api } from './client';

export interface TopTraders {
    long_pct: number | null;
    short_pct: number | null;
    ratio: number | null;
    ratio_24h_change_pct: number | null;
    trend: 'increasing_longs' | 'increasing_shorts' | 'neutral';
    history_ratio: number[];
    error?: string;
}

export interface TopAccounts {
    long_pct: number | null;
    short_pct: number | null;
    ratio: number | null;
    ratio_24h_change_pct: number | null;
    error?: string;
}

export interface OpenInterest {
    current: number | null;
    current_usdt: number | null;
    change_4h_pct: number | null;
    change_24h_pct: number | null;
    trend: 'accumulation' | 'distribution' | 'neutral';
    history: number[];
    error?: string;
}

export interface TakerFlow {
    ratio: number | null;
    buy_vol_24h: number;
    sell_vol_24h: number;
    ratio_24h_change_pct: number | null;
    trend: 'buyers_dominant' | 'sellers_dominant' | 'neutral';
    dominant: 'buyers' | 'sellers';
    history_ratio: number[];
    error?: string;
}

export interface SmartMoneyData {
    symbol: string;
    success: boolean;
    top_traders: TopTraders;
    top_accounts: TopAccounts;
    open_interest: OpenInterest;
    taker_flow: TakerFlow;
}

export async function fetchSmartMoney(symbol: string): Promise<SmartMoneyData> {
    return api.get<SmartMoneyData>(`/futures/smart-money?symbol=${symbol}`);
}
